import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { expandedRowFocus } from './DataConnectMultiClusterTableEntryCluster';

export type ExpandClusterButtonProps = Readonly<{
  isExpanded: boolean;
  setExpanded: (expand: boolean) => void;
  isDisabled: boolean;
}>;

export function ExpandClusterButton(props: ExpandClusterButtonProps) {
  const focusHighlight = props.isExpanded ? expandedRowFocus : '';
  return (
    <td className={`tb-data-grid-separator-row ${focusHighlight}`} style={{width: 37, textAlign: 'right'}}>
      <span className={'tb-data-grid-icon tb-padded-left-large'} data-tb-test-id={'cluster-expand-icon'}>
        <ButtonWidget
          buttonType={ButtonType.IconOutline}
          testId={'expand-cluster-button'}
          onClick={() => props.setExpanded(!props.isExpanded)}
          disabled={props.isDisabled}
        >
          {props.isExpanded ?
            <img src={imgPath('arrow_chevron_down_14px-small_new.svg')} alt={Messages.collapse()} />
            :
            <img src={imgPath('arrow_chevron_right_14px-small_new.svg')} alt={Messages.expand()} />
          }
        </ButtonWidget>
      </span>
    </td>
  );
}
